module.exports = __webpack_public_path__ + "img/mobile-white-logo.54f9dd53.svg";